import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { UserOTP } from '../../models/UserOTP.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { PeAuthService } from '../../../../core/services/auth.service';
import { PatientEngagementService } from '../../services/patient-engagement.service';
import { SMSservice } from '../../../../core/services/sms.service';
import { CommmonUtil } from '../utils/common.util';

@Component({
  selector: 'app-two-factor-verification',
  templateUrl: './two-factor-verification.component.html',
  styleUrl: './two-factor-verification.component.css',
  encapsulation: ViewEncapsulation.None,
})
export class TwoFactorVerificationComponent implements OnInit, OnDestroy {
  otpModel: UserOTP = new UserOTP();
  elinkData:any;
  elinkParams:any;
  profileJson:any; 
  otpForm!: FormGroup;
  invalidOTP: boolean = false; 
  isOtpChanged: boolean = false;
  isGuestUser:boolean= false;
  phInfo:any;
  PatientPhoneNo: any;
  currentYear: number;
  pharmacyLogo: any;
  pharmacyInfo: any;
  constructor(private _router: Router, 
              public auth:AuthService,  
              public fb: FormBuilder, 
              public _peAuth:PeAuthService,
              public _patientEngagementService:PatientEngagementService,
              public smsService:SMSservice, private commonUtil: CommmonUtil){
                this.currentYear = this.commonUtil.getCurrentYear();
              }
  
  ngOnInit(): void {    
      this.otpForm = this.fb.group({
        digit1: ['', [Validators.required, Validators.pattern('[0-9]+')]],
        digit2: ['', [Validators.required, Validators.pattern('[0-9]+')]],
        digit3: ['', [Validators.required, Validators.pattern('[0-9]+')]],
        digit4: ['', [Validators.required, Validators.pattern('[0-9]+')]],
        digit5: ['', [Validators.required, Validators.pattern('[0-9]+')]],
        digit6: ['', [Validators.required, Validators.pattern('[0-9]+')]],
      }); 
      this.otpForm.valueChanges.subscribe(() => {
        this.isOtpChanged = true; 
        this.invalidOTP = false;
      });
      this.elinkData = localStorage.getItem("eLinkData")!== 'undefined' ? JSON.parse(localStorage.getItem("eLinkData") || '{}') : {};
      this.PatientPhoneNo = this.formatPhone(this.elinkData);
      this.getPharmacyLogo();
  }

  async getPharmacyLogo() {
    this.elinkParams =  JSON.parse(localStorage.getItem('paramsData') as string);
    this.elinkData = JSON.parse(localStorage.getItem('eLinkData') as string);
    this.phInfo = {
      "pharmacyNpi": this.elinkParams?.npi,
      "patientId": this.elinkData?.EntityId,
      "isPharmacyLogoRequired": true
    };
    try {
      const resp = await this._patientEngagementService.getPharmacyLogo(this.phInfo).toPromise();
      if (resp) {
        try {
          const exists = await this._patientEngagementService.checkImageExists(resp.pharmacyLogo);
          if (exists) {
            this.pharmacyLogo = resp.pharmacyLogo;
          }
          this.pharmacyInfo = resp;
        } catch (error) {
          console.error('Error checking image existence:', error);
        }
      }
    } catch (error) {
      console.error('Error posting pharmacy info:', error);
    }
  }
  
  formatPhone(value:any){ 
      let temp = value?.PatientPhoneNo;
      let masked = temp?.replace(/\d(?=\d{4})/g, 'x'); 
      return masked?.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3'); 
  }
  onInputChange(event: Event, controlName: string) {
      const inputValue = (event.target as HTMLInputElement).value;
    if (!/^\d$/.test(inputValue)) {
        this.otpForm.controls[controlName].setValue('');
        return;
    }
    this.otpForm.controls[controlName].setValue(inputValue); 

    if (inputValue.length === 1) { 
        const nextIndex = +controlName[controlName.length - 1] + 1;
        if (nextIndex <= 6) {
            const nextControl = `digit${nextIndex}`;
            const nextElement = document.getElementById(nextControl);
            if (nextElement) {
                nextElement.focus();
            }
        }
      } else if (inputValue.length === 0) {  
        const prevIndex = +controlName[controlName.length - 1] - 1;
        if (prevIndex >= 1) {
            const prevControl = `digit${prevIndex}`;
            const prevElement = document.getElementById(prevControl);
            if (prevElement) {
                prevElement.focus();
            }
        }
    }
  }
  onKeyDown(event: KeyboardEvent, controlName: string) {
    const inputValue = (event.target as HTMLInputElement).value;

    if(event.key === 'Backspace' && inputValue.length === 0) {
      const prevIndex = +controlName[controlName.length - 1] - 1;
      if (prevIndex >= 1) {
          const prevControl = `digit${prevIndex}`;
          const prevElement = document.getElementById(prevControl);
          if (prevElement) {
              prevElement.focus();
              this.otpForm.controls[prevControl].setValue(''); 
          }
      }
    } else if (event.key >= '0' && event.key <= '9' && inputValue.length === 1) { 
        const nextIndex = +controlName[controlName.length - 1] + 1;
        if (nextIndex <= 6) {
            const nextControl = `digit${nextIndex}`;
            const nextElement = document.getElementById(nextControl);
            if (nextElement) {
                nextElement.focus();
            }
        }
    }
  }
  getMaskedValue(controlName: string): string {
    const control = this.otpForm.get(controlName);
    return control?.value ? '*' : '';
  }
  get f() {
    return this.otpForm.controls;
  }

  validateOTP(): void {
    this.elinkParams =  JSON.parse(localStorage.getItem('paramsData') as string);
    this.elinkData = JSON.parse(localStorage.getItem('eLinkData') as string);
    if (this.otpForm.invalid) { 
      this.otpForm.markAllAsTouched();
      return;
    }
    const otpValues = this.otpForm.value; 
    const otp = Object.values(otpValues).join('');
    const otpObj = {
      "otp": otp,
      "phoneNumber": this.elinkData?.PatientPhoneNo,
      "npi": this.elinkParams?.npi
    };
    if (this.elinkData) {
      this._patientEngagementService.postOTP(otpObj).subscribe(result =>{
        if(result) {
          this.phInfo = {
            "pharmacyNpi": this.elinkParams?.npi,
            "patientId": this.elinkData?.EntityId
          }
          this.smsService.patientPharmacyInfo();
          localStorage.setItem('MetaData', JSON.stringify(this.phInfo));
        }else{
          this.invalidOTP = true;
        }
      });
    } 
  }

  resendOTP(){
    this.invalidOTP = false;
    this.otpForm.reset();
    const elinkDataString = localStorage.getItem('eLinkData');
    const paramsDataString = localStorage.getItem('paramsData');
    try {
        this.elinkData = elinkDataString ? JSON.parse(elinkDataString) : {};
        this.elinkParams = paramsDataString ? JSON.parse(paramsDataString) : {};
        if (this.elinkData) {
          const otpObj = {
            "otp": '',
            "phoneNumber": this.elinkData?.PatientPhoneNo,
            "npi": this.elinkParams?.npi
          };
          this._patientEngagementService.postResendOTP(otpObj).subscribe(result =>{ 
            
          });
        }        
    } catch (error) {
        console.error("Error parsing eLinkData from localStorage:", error);
    }
  }
  ngOnDestroy() { 
  }
}
